// Hooks
import { useState } from "react";
// Common Components
import TabBox from "src/Components/Tabbox/TabBox";
// Local Components
import StatusSummary from "./StatusSummary";
import BuyingPowerSummary from "./BuyingPowerSummary";
import InventorySummary from "./InventorySummary";
import NakedOptionSummary from "./NakedOptionSummary";
import LimitDeviationSummary from "./LimitDeviationSummary";
import CoveredCallSummary from "./CoveredCallSummary";
import CoverageSummary from "./CoverageSummary";
import ImbalanceSummary from "./ImbalanceSummary";
import AssignmentDetails from "./AssignmentDetails";
import DetailedPortfolio from "./DetailedPortfolio";

enum ActiveTab {
  StatusSummary,
  BuyingPowerSummary,
  InventorySummary,
  NakedOptionSummary,
  LimitDeviationSummary,
  CoveredCallSummary,
  CoverageSummary,
  ImbalanceSummary,
  AssignmentDetails,
  DetailedPortfolio,
}
const PortfolioGroups = () => {
  const [activeTab, setActiveTab] = useState(ActiveTab.DetailedPortfolio);

  const getUI = () => {
    switch (activeTab) {
      case ActiveTab.StatusSummary:
        return <StatusSummary />;
      case ActiveTab.BuyingPowerSummary:
        return <BuyingPowerSummary />;
      case ActiveTab.InventorySummary:
        return <InventorySummary />;
      case ActiveTab.NakedOptionSummary:
        return <NakedOptionSummary />;
      case ActiveTab.LimitDeviationSummary:
        return <LimitDeviationSummary />;
      case ActiveTab.CoveredCallSummary:
        return <CoveredCallSummary />;
      case ActiveTab.CoverageSummary:
        return <CoverageSummary />;
      case ActiveTab.ImbalanceSummary:
        return <ImbalanceSummary />;
      case ActiveTab.AssignmentDetails:
        return <AssignmentDetails />;
      case ActiveTab.DetailedPortfolio:
        return <DetailedPortfolio />;
      default:
        return <></>;
    }
  };
  return (
    <div className="portfolio-groups-page flex flex-col justify-start items-start gap-3 borderrounded w-full p-3 h-full">
      <div className="max-w-min ml-5">
        <TabBox
          activeTab={activeTab}
          children={[
            { index: ActiveTab.DetailedPortfolio, title: "نگاه کلی پرتفو" },
            { index: ActiveTab.BuyingPowerSummary, title: "خلاصه قدرت خرید" },
            { index: ActiveTab.StatusSummary, title: "خلاصه وضعیت" },
            {
              index: ActiveTab.InventorySummary,
              title: "خلاصه طبقات دارایی به جز آپشن",
            },
            {
              index: ActiveTab.NakedOptionSummary,
              title: "خلاصه آپشن‌های Naked",
            },
            {
              index: ActiveTab.LimitDeviationSummary,
              title: "انحراف از سقف/کف",
            },
            {
              index: ActiveTab.CoveredCallSummary,
              title: "خلاصه کاوردکال" + " " + "(شورت)",
            },
            { index: ActiveTab.CoverageSummary, title: "خلاصه پوشش" },
            { index: ActiveTab.ImbalanceSummary, title: "خلاصه ناترازی" },
            { index: ActiveTab.AssignmentDetails, title: "جزئیات پرتفو" },
          ]}
          onChange={(_, i) => setActiveTab(i)}
        />
      </div>
      {getUI()}
    </div>
  );
};

export default PortfolioGroups;
